import { postUserV2Data } from 'services/userV2';

export async function postUserV2Token(data) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await postUserV2Data({
      url: '/token',
      data,
      withAuth: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}

